"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.methods = exports.initialState = void 0;
const fp = require("fp-ts");
const monocle = require("monocle-ts");
const ActionTypes = require("../../actionTypes/auth/login");
const CurrentActionTypes = require("../../actionTypes/auth/current");
exports.initialState = {
    status: 'STANDBY',
    isFederated: false,
    firstTime: true,
    provider: undefined,
    email: '',
    password: ''
};
const statusLens = monocle.Lens.fromProp('status');
const isFederatedLens = monocle.Lens.fromProp('isFederated');
const firstTimeLens = monocle.Lens.fromProp('firstTime');
const providerLens = monocle.Lens.fromProp('provider');
const emailLens = monocle.Lens.fromProp('email');
const passwordLens = monocle.Lens.fromProp('password');
const errorsLens = monocle.Lens.fromProp('errors');
exports.methods = {};
exports.methods[ActionTypes.SET_EMAIL] = (state, action) => emailLens.set(action.payload)(state);
exports.methods[ActionTypes.SET_PASSWORD] = (state, action) => passwordLens.set(action.payload)(state);
exports.methods[ActionTypes.LOGIN_REQUEST] = (state) => fp.function.compose(statusLens.set('LOGGING_IN'), errorsLens.set(undefined))(state);
exports.methods[ActionTypes.LOGIN_SUCCESS] = (state) => fp.function.compose(statusLens.set('LOGGED_IN'), emailLens.set(''), passwordLens.set(''), firstTimeLens.set(false))(state);
exports.methods[ActionTypes.LOGIN_FAILURE] = (state) => fp.function.compose(statusLens.set('FAILED'), passwordLens.set(''))(state);
exports.methods[ActionTypes.VALIDATE_LOGIN_FAILURE] = (state, action) => fp.function.compose(statusLens.set('FAILED'), errorsLens.set(action.payload.reduce((rv, x) => {
    ;
    (rv[x.key] = rv[x.key] || []).push(x.value);
    return rv;
}, {})))(state);
exports.methods[ActionTypes.IS_FEDERATED_SUCCESS] = (state, action) => fp.function.compose(isFederatedLens.set(action.payload.isFederated), providerLens.set(action.payload.provider))(state);
exports.methods[ActionTypes.EXCHANGE_CODE_FOR_TOKENS_REQUEST] = (state) => fp.function.compose(statusLens.set('LOGGING_IN'), errorsLens.set(undefined))(state);
exports.methods[ActionTypes.EXCHANGE_CODE_FOR_TOKENS_SUCCESS] = (state) => fp.function.compose(statusLens.set('LOGGED_IN'), firstTimeLens.set(false))(state);
exports.methods[ActionTypes.EXCHANGE_CODE_FOR_TOKENS_FAILURE] = (state) => statusLens.set('FAILED')(state);
exports.methods[CurrentActionTypes.REFRESH_TOKEN_SUCCESS] = (state) => fp.function.compose(statusLens.set('LOGGED_IN'), firstTimeLens.set(false))(state);
exports.methods[CurrentActionTypes.REFRESH_TOKEN_FAILURE] = (state) => statusLens.set('EXPIRED')(state);
exports.methods[ActionTypes.LOGOUT] = () => (Object.assign({}, exports.initialState));
//# sourceMappingURL=login.js.map